import { tap, map } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { SmarticoPromotionLog } from '@core/models/smartico-promotion-log.model';

@Injectable()
export class SmarticoPromotionLogDataService extends DefaultDataService<SmarticoPromotionLog>  {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('SmarticoPromotionLog', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<SmarticoPromotionLog[]> {
    return this.http.get<ApiResponse>('/crm/smartico/bonuslog').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<SmarticoPromotionLog[]>{
    console.log('getWithQuery');
    return this.http.get<ApiResponse>(`/crm/smartico/bonuslog${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows.map(row => ({
        ...row,
        request_detail: JSON.stringify({
          bonus_cash_amount: row.bonus_cash_amount,
          free_spins_count: row.free_spins_count,
          currency: row.currency,
          game_id: row.game_id,
          expiry_datetime: row.expiry_datetime
        })
      })))
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
